/* eslint-disable */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { OptionItem, QueryFieldModel, SelectUtils, UiConstants } from '../../../util/core-utils';
import { InputMask } from '../../../util/input-masks';
import { BreadcrumbParent } from '../../../shared/breadcrumb/breadcrumb/breadcrumb.component';
import { RightModel } from '../../../app.rights';
import { OrderType, QueryResult } from '../../../lib/util/services';
import { TranslateService } from '@ngx-translate/core';
import { RightResolver, RightService } from '../../../lib/right.service';
import { combineLatest, Observable } from 'rxjs';
import { Arrays } from '../../../lib/util/arrays';
import { Strings } from '../../../lib/util/strings';
import { Set } from 'immutable';
import { StateName } from '../../../app.state-names';
import { EmptyMessage } from '../../../lib/util/messages';
import { Dates, OffsetDateTime } from '../../../lib/util/dates';
import { DisabledEnum, DisabledItem } from '../../../util/search-utils';
import { DropdownItemType } from '../../../shared/dropdown/dropdown-item/dropdown-item-type';
import {SmsTemplate, SmsTemplateService} from "../../../lib/sms/sms-template/sms-template.service";
import {SmsTemplateSearch, SmsTemplateSearchService} from "../../../lib/sms/sms-template/sms-template-search.service";
/* eslint-enable */

@Component({
  selector: 'app-sms-template-list',
  templateUrl: './sms-template-list.component.html',
  styleUrls: ['./sms-template-list.component.scss']
})
export class SmsTemplateListComponent implements OnInit, OnDestroy {
  SmsTemplate = SmsTemplate;
  SelectUtils = SelectUtils;
  InputMask = InputMask;
  UiConstants = UiConstants;
  DropdownItemType = DropdownItemType;

  breadcrumbParents: BreadcrumbParent[] = [];
  breadcrumbSelf: string;
  compactSidebar: boolean = document.querySelector('body')!.classList.contains('sidebar-compact');
  showSearch: boolean = false;
  rightModel: RightModel = RightModel.empty();
  queryModel: QueryFieldModel<SmsTemplate.OrderField> = new QueryFieldModel(SmsTemplate.OrderField.ID, OrderType.DESC);

  searchResult: SmsTemplateSearch.SearchDataResult;
  searchModel: SmsTemplateSearchModel = new SmsTemplateSearchModel();
  disabledItems: DisabledItem[] = [];

  smsTemplateList: SmsTemplateModel[] = [];

  constructor(private smsTemplateService: SmsTemplateService,
              private translateService: TranslateService,
              private rightService: RightService,
              private smsTemplateSearchService: SmsTemplateSearchService) { }

  ngOnInit() {
    this.loadRightModels();
    this.loadSearch(() => {
      this.showSearch = !this.searchModel.isEmpty();
      this.initDisabledOptions(DisabledEnum.FALSE);
      this.loadList();
    });
    this.initBreadcrumb();
  }

  private loadRightModels() {
    this.rightService.getRightResolver().subscribe(
      (resolver: RightResolver) => {
        this.rightModel = RightModel.of(resolver);
      }
    );
  }

  private loadSearch(completion: () => void) {
    const obs: Observable<SearchLoadResult> = combineLatest(
      this.smsTemplateSearchService.getSearchData({}),
      (storedSearchData: SmsTemplateSearch.SearchDataResult) => {
        const result: SearchLoadResult = {
          storedSearchData: storedSearchData
        };
        return result;
      }
    );
    obs.subscribe(
      (result: SearchLoadResult) => {
        this.searchResult = result.storedSearchData;
        this.postInitSearch(result.storedSearchData, completion);
      }
    );
  }

  private postInitSearch(storedSearchData: SmsTemplateSearch.SearchDataResult, completion: () => void) {
    this.queryModel.itemsPerPage = storedSearchData.searchData.itemsPerPage;
    this.queryModel.currentPage = storedSearchData.searchData.pageNumber;
    this.queryModel.setOrder(storedSearchData.searchData.order);
    this.searchModel.name = storedSearchData.searchData.name;
    this.searchModel.disabled = storedSearchData.searchData.disabled;
    completion()
  }

  private initDisabledOptions(initValue: DisabledEnum) {
    this.disabledItems = [];
    const disabledEnums: DisabledEnum[] = [DisabledEnum.NONE, DisabledEnum.FALSE, DisabledEnum.TRUE];
    Arrays.iterateByIndex(disabledEnums, (key) => {
      const item = new DisabledItem();
      item.id = key;
      this.translateService.get('COMMON_VALUE_DISABLED_ENUM_' + key).subscribe(
        (text: string) => {
          item.text = text;
        }
      );
      this.disabledItems.push(item);
      if (!this.searchModel.disabled) {
        if (key === initValue) {
          this.searchModel.disabled = item;
        }
      }
    });
  }

  loadList(pageNumber?: number) {
    const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
    const order = this.queryModel.getOrder();
    const disabled: boolean | undefined = !this.searchModel.disabled ||
    this.searchModel.disabled.id === DisabledEnum.NONE ?
      undefined : this.searchModel.disabled.id === DisabledEnum.TRUE;
    this.smsTemplateService.query({
      name: Strings.undefinedOrNonEmpty(this.searchModel.name),
      disabled: disabled,
      orders: Set.of(order),
      paging: requestedPage ? {
        pageNumber: requestedPage,
        numberOfItems: this.queryModel.itemsPerPage
      } : undefined
    }).subscribe((result: QueryResult<SmsTemplate.SmsTemplate>) => {
      this.smsTemplateList = [];
      result.items.forEach((smsTemplate: SmsTemplate.SmsTemplate) => {
        const smsTemplateModel = new SmsTemplateModel();
        smsTemplateModel.id = smsTemplate.id + '';
        smsTemplateModel.externalId = smsTemplate.externalId;
        smsTemplateModel.name = smsTemplate.name;
        smsTemplateModel.creationTime = smsTemplate.creationTime;
        smsTemplateModel.updateTime = smsTemplate.updateTime;
        smsTemplateModel.disabled = smsTemplate.disabled;
        this.smsTemplateList.push(smsTemplateModel);
      });
      this.queryModel.currentPage = requestedPage;
      this.queryModel.totalNumberOfItems = result.pagingResult.totalNumberOfItems;
      this.queryModel.currentNumberOfItems = result.pagingResult.currentNumberOfItems;
    });
  }

  onSearchClicked() {
    this.loadList(1);
  }

  onSearchReset() {
    this.smsTemplateSearchService.resetSearchData({}).subscribe(
      (result) => {
        this.loadSearch(() => {
          this.showSearch = true;
          this.loadList(1);
        });
      }
    );
  }

  private saveSearch() {
    const request = {
      searchData: {
        itemsPerPage: this.queryModel.itemsPerPage,
        pageNumber: this.queryModel.currentPage,
        order: this.queryModel.getOrder(),
        name: this.searchModel.name,
        disabled: this.searchModel.disabled,
      }
    };
    this.smsTemplateSearchService.setSearchData(request).subscribe(
      (result) => {
      },
      (error) => {
      }
    );
  }

  initBreadcrumb() {
    this.translateService.get('SMS_TEMPLATE_LIST_HEADER').subscribe(
      (result: string) => {
        this.breadcrumbSelf = result;
      }
    );
    this.translateService.get('MENU_NAVBAR_MENU_ADMINISTRATION').subscribe(
      (result: string) => {
        this.breadcrumbParents.push({name: result, uiSref: StateName.ADMIN_DASHBOARD});
      }
    );
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
  }

  orderBy(field: SmsTemplate.OrderField) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  setDisabled(event: any, smsTemplate: SmsTemplate.SmsTemplate, disabled: boolean) {
    this.smsTemplateService.setDisabled({
      id: smsTemplate.id,
      disabled: disabled
    }).subscribe(
      (result: EmptyMessage) => {
        this.loadList();
      },
      (error: any) => {
        this.loadList();
      }
    );
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  ngOnDestroy() {
    this.saveSearch();
  }

}

class SmsTemplateModel {
  id: string = '';
  externalId: string = '';
  name: string = '';
  creationTime: OffsetDateTime = Dates.emptyOffsetDateTime();
  updateTime: OffsetDateTime = Dates.emptyOffsetDateTime();
  disabled = false;
}

class SmsTemplateSearchModel {
  name: string;
  disabled?: DisabledItem;

  public isEmpty(): boolean {
    return this.name.length === 0
      && OptionItem.idOrUndefined(this.disabled) === undefined
      ;
  }

  public clear() {
    this.name = '';
    this.disabled = undefined;
  }

  constructor() {
  }

}

interface SearchLoadResult {
  storedSearchData: SmsTemplateSearch.SearchDataResult,
}
